import React from "react";
import { Link } from 'react-router-dom';
import appLogo from "../assets/Guide_uni_logo.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => {
  return (
    <div className="header">
      <div className="header-top"></div>
      <div className="container-fluid">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">
                <img src={appLogo} alt="FlyUrDream Logo" height="40" />
              </Link>

              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link className="nav-link active" to="/">Universities</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/">Recruiters</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/">Aggregators</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link ext-link" to="https://crm.guideuni.com/">Login</Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;